function formatDate(date: string, type?: 'invert'): string {
  if (!type) {
    const [dd, mm, yyyy] = date.split('/');

    return `${yyyy}-${mm}-${dd}`;
  }
  const [yyyy, mm, dd] = date.split('-');

  return `${dd}/${mm}/${yyyy}`;
}

export default formatDate;
